import React, { useRef, useEffect } from "react";
import { Loader } from "semantic-ui-react";

import { useFetchChatSessionByIdQuery } from "./chatSessionApiSlice";
import { utteranceLabels, utteranceUnit } from "../evaluation_sessions/evaluationRules";
import "./ChatSessionDetail.css";

const ChatSessionDetail = (props) => {
  const messageRef = useRef(null);
  const setDetailedChatSession = props.set_detailed_chat_session;

  const {
    data: chatSession,
    isLoading,
    isSuccess,
    isError,
    error,
  } = useFetchChatSessionByIdQuery(props.chat_session_id, {
    pollingInterval: 5000,
  });

  useEffect(() => {
    if (isSuccess && setDetailedChatSession) {
      setDetailedChatSession(chatSession);
    }
  }, [isSuccess, chatSession, setDetailedChatSession]);

  if (isLoading) {
    return <Loader active />;
  }

  if (isError) return null;

  // Evaluation text cites trainee sentences by number; show those numbers on the bubbles.
  const labels = utteranceLabels(props.evaluatedCriteria);
  const unit = utteranceUnit(props.evaluatedCriteria);

  let content;

  content = (
    <div ref={messageRef} style={{ padding: '20px 0', minHeight: '100%' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', padding: '0 16px' }}>
        {chatSession.chatlog_set.map((message, index) => (
          <div
            key={message.id}
            style={{
              display: 'flex',
              justifyContent: message.speaker === "H" ? 'flex-end' : 'flex-start',
              alignItems: 'flex-end',
              gap: '6px',
              padding: '0 4px'
            }}
          >
            {labels[message.id] && (
              <span
                title="평가 내용에서 이 번호로 이 발화를 가리킵니다"
                style={{ fontSize: '11px', lineHeight: 1.3, color: '#86868b', whiteSpace: 'nowrap',
                         textAlign: 'center', paddingBottom: '4px' }}
              >
                {unit}<br />
                <span style={{ fontSize: '12px', fontWeight: 600, color: '#007AFF' }}>{labels[message.id]}</span>
              </span>
            )}
            <div
              id={message.id}
              style={{
                maxWidth: '85%',
                padding: '10px 16px',
                borderRadius: '18px',
                fontSize: '15px',
                lineHeight: '1.5',
                backgroundColor: message.speaker === "H" ? '#007AFF' : '#E9E9EB',
                color: message.speaker === "H" ? 'white' : 'black',
                borderBottomRightRadius: message.speaker === "H" ? '4px' : '18px',
                borderBottomLeftRadius: message.speaker === "H" ? '18px' : '4px',
                boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                wordBreak: 'break-word',
                transition: 'all 0.3s ease'
              }}
            >
              {message.utterance}
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return content;
};

export default ChatSessionDetail;
